const VERSION_PO = process.env.REACT_APP_VERSION_PO ?? '';
const isProd = VERSION_PO && Number(VERSION_PO.split('.')[0]);

const API_URL = isProd
  ? require('constants/apiUrl').PRODUCT_API_URL
  : 'https://api.portal.tech24.kz/v2';

export { API_URL };
